import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import RedSeguridadGlobal from "@/components/RedSeguridadGlobal";
import { installGlobalChunkReload } from "@/utils/chunkReload";

// Auto-recarga 1 vez si un chunk lazy no carga (pestaña vieja tras deploy).
// Red de seguridad para fallos que no caen en un ErrorBoundary de React.
installGlobalChunkReload();

// Suprimir error de ResizeObserver que no afecta la funcionalidad
// Este error ocurre con componentes Select de Radix UI
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // Usar requestAnimationFrame para evitar el loop error
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

// También suprimir el error si llega a la consola
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* RED DE SEGURIDAD GLOBAL (Ann 2026-07-16: "monta la red de seguridad global,
        cada día más seguros"). La app NO tenía ErrorBoundary global: cualquier
        fallo de render tiraba el árbol entero y dejaba la PANTALLA EN BLANCO, sin
        mensaje y sin salida — la clienta concluía que la plataforma estaba rota.
        Ahora: mensaje claro, salidas (reintentar / recargar / inicio) y chivatazo
        del error para poder arreglarlo en vez de adivinarlo. */}
    <RedSeguridadGlobal>
      <App />
    </RedSeguridadGlobal>
  </React.StrictMode>,
);
